module.exports = __webpack_public_path__ + "static/media/Best-Worst-Leader-wordmark.35fa91f3.png";